/**
 * Snow Effect - CSS-based falling snow animation
 * Uses background-image animation for better performance
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'theme_snow_enabled';
  const SNOW_CONTAINER_ID = 'snow-effect-container';
  
  let snowContainer = null;
  let isEnabled = false;

  /**
   * Check if user prefers reduced motion
   */
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Get user toggle state from localStorage
   */
  function getUserToggleState() {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null ? stored === 'true' : null;
  }

  /**
   * Set user toggle state in localStorage
   */
  function setUserToggleState(enabled) {
    localStorage.setItem(STORAGE_KEY, enabled.toString());
  }

  /**
   * Check if snow should be enabled
   */
  function shouldEnableSnow() {
    const userPreference = getUserToggleState();
    // If user has explicitly toggled, respect that preference
    if (userPreference !== null) {
      return userPreference;
    }
    // Otherwise, use theme setting (container exists)
    return snowContainer !== null;
  }

  /**
   * Start snow effect
   */
  function startSnow() {
    if (prefersReducedMotion()) {
      return;
    }
    
    if (!snowContainer) {
      return;
    }
    
    isEnabled = true;
    snowContainer.style.display = 'block';
  }

  /**
   * Stop snow effect
   */
  function stopSnow() {
    isEnabled = false;
    
    if (snowContainer) {
      snowContainer.style.display = 'none';
    }
  }

  /**
   * Toggle snow effect
   */
  function toggle() {
    const newState = !isEnabled;
    setUserToggleState(newState);
    
    if (newState) {
      startSnow();
    } else {
      stopSnow();
    }
    
    // Dispatch custom event for toggle button updates
    document.dispatchEvent(new CustomEvent('snow:toggle', { 
      detail: { enabled: newState } 
    }));
  }

  /**
   * Initialize snow effect
   */
  function init() {
    snowContainer = document.getElementById(SNOW_CONTAINER_ID);
    
    if (!snowContainer) {
      return;
    }
    
    // Set accessibility attributes
    snowContainer.setAttribute('aria-hidden', 'true');
    
    // Check if snow should be enabled
    if (shouldEnableSnow()) {
      startSnow();
    } else {
      stopSnow();
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }

  // Re-initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(init, 100);
  });

  // Expose toggle function globally
  window.SnowEffect = {
    toggle: toggle,
    isEnabled: () => isEnabled,
    start: startSnow,
    stop: stopSnow
  };
})();
